import React from "react";

export default class ErrorBoundary extends React.Component {
    state = { error: null, info: null };

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        try {
            console.error("WebApp ErrorBoundary", error, info?.componentStack);
        } catch (_) {}
        this.setState({ info });
    }

    handleReload = () => {
        try {
            window.location.reload();
        } catch (_) {}
    };

    handleRetry = () => {
        this.setState({ error: null, info: null });
    };

    render() {
        const { error, info } = this.state;
        if (!error) return this.props.children;

        const message = error?.message || String(error);
        const stack = error?.stack || "";
        const componentStack = info?.componentStack || "";

        return (
            <div style={styles.container}>
                <h2 style={styles.title}>Erreur dans l'interface</h2>
                <p style={styles.subtitle}>L'interface a rencontré un problème. Vous pouvez la recharger.</p>

                <div style={styles.box}>
                    <div style={styles.label}>Message</div>
                    <pre style={styles.pre}>{message}</pre>
                    {stack && <>
                        <div style={styles.label}>Stack</div>
                        <pre style={styles.preSmall}>{stack}</pre>
                    </>}
                    {componentStack && <>
                        <div style={styles.label}>Component Stack</div>
                        <pre style={styles.preSmall}>{componentStack}</pre>
                    </>}
                </div>

                <div style={styles.buttons}>
                    <button onClick={this.handleReload} style={styles.btnPrimary}>Recharger la page</button>
                    <button onClick={this.handleRetry} style={styles.btnSecondary}>Réessayer</button>
                </div>
            </div>
        );
    }
}

const styles = {
    container: {
        position: "fixed",
        top: 0, left: 0, right: 0, bottom: 0,
        backgroundColor: "#1a1a1a",
        color: "#fff",
        padding: 20,
        overflow: "auto",
        fontFamily: "system-ui, sans-serif",
        zIndex: 99999,
    },
    title: { color: "#ff6b6b", marginTop: 30 },
    subtitle: { color: "#ddd" },
    box: {
        backgroundColor: "#000",
        borderRadius: 8,
        padding: 12,
        marginTop: 20,
        maxHeight: "55vh",
        overflow: "auto",
    },
    label: { color: "#ffb86c", fontWeight: "bold", marginTop: 6 },
    pre: { color: "#fff", whiteSpace: "pre-wrap", margin: 0 },
    preSmall: { color: "#bbb", whiteSpace: "pre-wrap", fontSize: 11, margin: 0 },
    buttons: { display: "flex", gap: 10, marginTop: 20 },
    btnPrimary: {
        flex: 1, padding: 12, borderRadius: 8, border: "none",
        backgroundColor: "#4caf50", color: "#fff", fontWeight: "bold",
    },
    btnSecondary: {
        flex: 1, padding: 12, borderRadius: 8, border: "none",
        backgroundColor: "#2196f3", color: "#fff", fontWeight: "bold",
    },
};
